import { useCallback, useState } from 'react'
import { VisitorRegistrationFormSubcontractor } from '../../../../../types/Company'
import Dialog from '../../../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../../../atoms/layout/Flex'
import Button from '../../../../atoms/inputs/Button'
import Label from '../../../../atoms/display/Label'
import Alert from '../../../../atoms/feedback/Alert'
import { useVisitorRegistrationFormSubcontractorCreateDialog } from '../../../../../hooks/useDialog'

type Props = {
  open: boolean
  onClose: () => void
  subcontractors: VisitorRegistrationFormSubcontractor[]
  selectedSubcontractors: VisitorRegistrationFormSubcontractor[]
  onSelect: (subcontractors: VisitorRegistrationFormSubcontractor[]) => void
}

export default function VisitorRegistrationSubcontractorSelectDialog(props: Props) {
  const { open, onClose, subcontractors, selectedSubcontractors, onSelect } = props
  const createDialog = useVisitorRegistrationFormSubcontractorCreateDialog()
  const [selectedIds, setSelectedIds] = useState<string[]>(
    selectedSubcontractors.map((subcontractor) => subcontractor.id)
  )

  const handleSelect = useCallback(
    (subcontractor: VisitorRegistrationFormSubcontractor) => {
      setSelectedIds([...selectedIds, subcontractor.id])
    },
    [setSelectedIds, selectedIds]
  )

  const handleUnSelect = useCallback(
    (subcontractor: VisitorRegistrationFormSubcontractor) => {
      setSelectedIds(selectedIds.filter((id) => id !== subcontractor.id))
    },
    [setSelectedIds, selectedIds]
  )

  const handleSetting = useCallback(() => {
    onSelect(subcontractors.filter((subcontractor) => selectedIds.includes(subcontractor.id)))
    onClose()
  }, [onSelect, onClose, subcontractors, selectedIds])

  return (
    <Dialog
      open={open}
      width="xs"
      onClose={onClose}
      title="下請けの選択"
      actions={<Button onClick={handleSetting}>設定</Button>}
    >
      <FlexColumn>
        <Button height="small" onClick={() => createDialog.open()}>
          下請け情報の登録
        </Button>
        {subcontractors.length === 0 && <Alert severity="info">下請け情報が登録されていません</Alert>}
        {subcontractors.map((subcontractor) => (
          <FlexRow key={subcontractor.id} align="center">
            {selectedIds.includes(subcontractor.id) ? (
              <Button size="sm" height="small" color="caution" onClick={() => handleUnSelect(subcontractor)}>
                <Label text="選択中" variant="caption" />
              </Button>
            ) : (
              <Button size="sm" height="small" onClick={() => handleSelect(subcontractor)}>
                <Label text="選択" variant="caption" />
              </Button>
            )}
            <Label text={subcontractor.name} />
          </FlexRow>
        ))}
      </FlexColumn>
    </Dialog>
  )
}
